<template>
<div class="mReportContent" v-show="isSuccess">
    <div class="new_report_box">
        <div class="title_box">
            <div class="title_text_box">
                <label></label>
                <span>最新报告</span>
            </div>
            <div @click="toSearch()" class="more_text_box">更多 ></div>
        </div>
        <div class="report_warp">
            <div @click="toReportDetails(item)" class="new_report_item" v-for="(item, index) in reportInfoData.newreportlist" :key="index">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="report_info_div">
                    <div class="van-multi-ellipsis--l2">{{item.subject}}</div>
                    <div class="tag_div">
                        <img :src="require('@/common/images/report/mobile/icon_tag.png')" alt="">
                        <span>{{item.industryname}}</span>
                        <span>{{item.industryname2}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="limited_report_box">
        <div class="title_box">
            <div class="title_text_box">
                <label></label>
                <span>限时折扣</span>
            </div>
        </div>
        <div class="report_warp">
            <div @click="toReportDetails(item)" class="limited_report_item" v-for="(item, index) in reportInfoData.limitedtimelist" :key="index">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="subject_box">{{item.subject}}</div>
                <div class="item_bottom_box">
                    <div class="left_div">
                        <span>￥{{item.saleprice}} </span>
                        <span>￥{{item.uprice}}</span>
                    </div>
                    <div class="right_div">抢购</div>
                </div>
            </div>
        </div>
    </div>
    <mHotReportList></mHotReportList>
    <mFreeReportList></mFreeReportList>
    <div class="everybody_love_report_box">
        <div class="title_box">
            <div class="title_text_box">
                <label></label>
                <span>大家都爱看</span>
            </div>
        </div>
        <div class="report_warp">
            <div @click="toReportDetails(item)" class="everybody_love_report_item" v-for="(item, index) in reportInfoData.everyonelikelist" :key="index">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="subject_box">{{item.subject}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mFreeReportList from 'views/reportMobile/index/components/mFreeReportList'
import mHotReportList from 'views/reportMobile/index/components/mHotReportList'
import {getIndexReport} from 'api/reportApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mReportContent',
    data() {
        return {
            isSuccess: false,
            reportInfoData: {
                newreportlist: [],
                limitedtimelist: [],
                everyonelikelist: []
            }
        }
    },
    mounted() {
        this.findIndexReportInfo()
    },
    methods: {
        // 点击报告
        toReportDetails(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'MReportDetails', query: {'reportid': val.innerid}})
        },
        // 更多按钮
        toSearch() {
            this.setRefresh(true)
            this.$router.push({name: 'MReportSearch'})
        },
        findIndexReportInfo() {
            this.setLoading(true)
            getIndexReport({
                data: {
                    page: 1,
                    pageSize: 6
                },
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.reportInfoData = data.data
                    this.isSuccess = true
                },
                error: data => {
                    this.isSuccess = false
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {
        mFreeReportList,
        mHotReportList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mReportContent {
    margin-top: 0.2rem;
    box-sizing: border-box;
    font-family:PingFangSC-Regular,PingFang SC;
    .title_box {
        padding: 0.28rem 0;
        display: flex;
        justify-content: space-between;
        line-height: 0.46rem;
        .title_text_box {
            &>label {
                display: inline-block;
                box-sizing: border-box;
                width: 0.2rem;
                height: 0.2rem;
                border: 0.04rem solid rgba(64,158,255,1);
                border-radius: 0.1rem;
            }
            &>span {
                margin-left: 0.12rem;
                color: #333;
                font-size: 0.32rem;
                font-weight: bold;
            }
        }
        .more_text_box {
            color: #999;
            font-size: 0.24rem;
        }
        .refresh_box {
            display: flex;
            align-items: center;
            &>img {
                width: 0.22rem;
                height: 0.22rem;
                margin-right: 0.12rem;
            }
            &>span {
               color: #999;
                font-size: 0.24rem; 
            }
        }
    }
    .new_report_box {
        // padding: 0.28rem 0;
        background-color: #fff;
        padding: 0 0.32rem;
        .new_report_item {
            padding-bottom: 0.28rem;
            display: flex;
            .img_box {
                margin-right: 0.24rem;
                padding-right: 0.1rem;
                // background-image: url('./../../../../common/images/report/mobile/icon_bg.png');
                background-image: url('./../../../../common/images/report/index/img_bg.png');
                background-repeat: no-repeat;
                background-position: right center;
                background-size: 2.3rem 1.32rem;
                &>img {
                    position: relative;
                    width: 2.2rem;
                    min-width: 2.2rem;
                    height: 1.32rem;
                    min-height: 1.32rem;
                }
            }
            .report_info_div {
                .van-multi-ellipsis--l2 {
                    color: #333;
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    font-weight: bold;
                    text-align: justify;
                    margin-bottom: 0.2rem;
                }
                .tag_div {
                    display: flex;
                    align-items: center;
                    line-height: 0.28rem;
                    &>img {
                        width: 0.18rem;
                        height: 0.18rem;
                    }
                    &>span {
                        font-size: 0.2rem;
                        color: #999;
                    }
                    &>span:nth-of-type(1) {
                        margin: 0 0.12rem;
                    }
                }
            }
        }
    }
    .limited_report_box, .everybody_love_report_box {
        padding: 0 0.32rem;
        background-color: #fff;
        margin-top: 0.2rem;
        .report_warp {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .limited_report_item,  .everybody_love_report_item{
                width: 3.3rem;
                padding-bottom: 0.28rem;
                .img_box {
                    padding-right: 0.1rem;
                    // background-image: url('./../../../../common/images/report/mobile/icon_bg.png');
                    background-image: url('./../../../../common/images/report/index/img_bg.png');
                    background-repeat: no-repeat;
                    background-position: right center;
                    background-size: 3.28rem 1.88rem;
                    &>img {
                        position: relative;
                        width: 3.18rem;
                        min-width: 3.18rem;
                        height: 1.88rem;
                        min-height: 1.88rem;
                    }
                }
                .subject_box {
                    // background-color: pink;
                    // padding-right: 0.12rem;
                    // height: 0.8rem;
                    color: #333;
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    font-weight: bold;
                    // text-align: justify;
                    margin: 0.2rem 0;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .item_bottom_box {
                    margin-bottom: 0.04rem;
                    display: flex;
                    line-height: 0.48rem;
                    text-align: center;
                    .left_div {
                        background-color: #D92430;
                        width: 2.44rem;
                        color: #fff;
                        display: flex;
                        align-items: center;
                        // justify-content: center;
                        padding-left: 0.2rem;
                        &>span:nth-of-type(1) {
                            font-size: 0.24rem;
                            font-weight: bold;
                        }
                        &>span:nth-of-type(2) {
                            margin-left: 0.1rem;
                            font-size: 0.18rem;
                            text-decoration: line-through;
                        }
                    }
                    .right_div {
                        color: #D92430;
                        width: 0.84rem;
                        border: 0.02rem solid #D92430;
                        box-sizing: border-box;
                        font-size: 0.24rem;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .everybody_love_report_box {
        .report_warp {
            .everybody_love_report_item {
                .subject_box {
                    height: auto;
                    margin-bottom: 0;
                }
            }
        }
    }
    .mReportList {
        padding: 0 0.32rem;
        background-color: #fff;
        margin-top: 0.2rem;
        padding-bottom: 0.08rem;
        .report_list_warp {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .report_list_item {
                .report_big_box {
                    width: 3.3rem;
                    padding-bottom: 0.28rem;
                    .img_box {
                        padding-right: 0.1rem;
                        background-image: url('./../../../../common/images/report/index/img_bg.png');
                        background-repeat: no-repeat;
                        background-position: right center;
                        background-size: 3.28rem 1.88rem;
                        &>img {
                            position: relative;
                            width: 3.18rem;
                            min-width: 3.18rem;
                            height: 1.88rem;
                            min-height: 1.88rem;
                        }
                    }
                    .van-multi-ellipsis--l2 {
                        padding-right: 0.12rem;
                        color: #333;
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        font-weight: bold;
                        // text-align: justify;
                        margin-top: 0.2rem;
                    }
                }
                .report_little_box {
                    margin-bottom: 0.2rem;
                    width: 6.85rem;
                    height: 0.4rem;
                    display: flex;
                    align-items: center;
                    .img_box {
                        width: 0.28rem;
                        max-width: 0.28rem;
                        height: 0.28rem;
                        max-height: 0.28rem;
                        background-color: #e5e5e5;
                        margin-right: 0.2rem;
                        &>img {
                            width: 0.28rem;
                            max-width: 0.28rem;
                            height: 0.28rem;
                            max-height: 0.28rem;
                            background-size: 100% 100%;
                        }
                    }
                    .van-ellipsis {
                        color: #333;
                        font-size: 0.28rem;
                    }
                }
            }
        }
    }
}
</style>